import * as type from "../action-types";

type load = { id: string }

export const getClientSizesAction = (payload?: load) => ({
    type: type.GET_CLIENT_SIZES
});
